import { Grid, GridItem } from "@chakra-ui/react"
import { Downline, IconButton, Pressable, Section } from "components"
import { useConsultantDownlines } from "hooks"
import { useNavigate, useParams } from "react-router"

export default function Downlines(){

    const navigate = useNavigate()
    const params = useParams()
    const downlines = useConsultantDownlines(params?.id)

    return(
    <>
    <Section title="Downlines diretos">
        <IconButton label="Atualizar" size="xs" icon="refresh" isLoading={downlines.isFetching} onClick={downlines.refetch} />
    </Section>

    <Grid templateColumns="33% 33% 33%" gap={4}>
        { downlines.data?.map(item => <GridItem key={item.id}><Pressable isDisabled={item.name === 'Consultor Expirado'} onClick={() => navigate(`/consultants/${item.id}`)}><Downline data={item} /></Pressable></GridItem>)}
    </Grid>
    </>
    )
}